/* ============================================
   ProFRSH Product Form - Add to Cart Handler
   ============================================ */
window.Profrsh = window.Profrsh || {};

Profrsh.ProductForm = class {
  constructor(container) {
    this.form = container.tagName === 'FORM' ? container : container.querySelector('form');
    if (!this.form) return;
    this.submitBtn = this.form.querySelector('[type="submit"]');
    this.errorEl = this.form.querySelector('[data-product-form-error]');
    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });

    /* Selling plan handled by inline script in product-hero.liquid */
  }

  async handleSubmit() {
    if (!this.submitBtn || this.submitBtn.disabled) return;

    this.submitBtn.disabled = true;
    this.submitBtn.classList.add('is-loading');
    if (this.errorEl) this.errorEl.hidden = true;

    const formData = new FormData(this.form);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart');
      }

      const item = await res.json();

      /* Update cart */
      if (window.profrshCart) await window.profrshCart.getCart();

      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item } }));

      /* Button success state */
      this.submitBtn.classList.add('is-success');
      const textEl = this.submitBtn.querySelector('[data-add-to-cart-text]');
      const origText = textEl ? textEl.textContent : this.submitBtn.textContent;
      if (textEl) {
        textEl.textContent = 'Added!';
        setTimeout(() => {
          this.submitBtn.classList.remove('is-success');
          textEl.textContent = origText;
          this.submitBtn.disabled = false;
        }, 2000);
      } else {
        this.submitBtn.textContent = 'Added!';
        setTimeout(() => {
          this.submitBtn.classList.remove('is-success');
          this.submitBtn.textContent = origText;
          this.submitBtn.disabled = false;
        }, 2000);
      }

    } catch (err) {
      if (this.errorEl) {
        this.errorEl.textContent = err.message;
        this.errorEl.hidden = false;
      }
      this.submitBtn.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: err.message } }));
    } finally {
      this.submitBtn.classList.remove('is-loading');
    }
  }

};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach(form => {
    if (!form._productFormBound) {
      form._productFormBound = true;
      new Profrsh.ProductForm(form);
    }
  });
});

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('[data-product-form]').forEach(form => {
    if (!form._productFormBound) {
      form._productFormBound = true;
      new Profrsh.ProductForm(form);
    }
  });
});
